<template>
  <div class="transfer-confirm-page">
    <main class="transfer-main">
      <section class="merchant-card">
        <div class="merchant-row">
          <div class="merchant-avatar">
            <img :src="merchantIcon" alt="" />
          </div>
          <div class="merchant-meta">
            <div class="pay-title">{{ isProductQrc ? '商品收款' : '向商户付款' }}</div>
            <div class="merchant-name">{{ merchantDisplayName }}</div>
          </div>
        </div>
      </section>

      <section class="transfer-option-card">
        <button
          type="button"
          class="transfer-option"
          :class="{ active: selectedAction === 'transfer' }"
          @click="selectedAction = 'transfer'"
        >
          <span class="radio-dot"></span>
          <span>转账</span>
        </button>
      </section>
    </main>

    <section class="confirm-bar">
      <button class="confirm-button" type="button" :disabled="loading || selectedAction !== 'transfer'" @click="confirmTransfer">
        {{ loading ? '加载中' : '确认转账' }}
      </button>
    </section>
  </div>
</template>

<script>
import { getPayOrderInfo } from '@/api/api'
import config from '@/config'
import wayCodeUtils from '@/utils/wayCode'

export default {
  data() {
    return {
      loading: true,
      selectedAction: 'transfer',
      payOrderInfo: {},
      isProductQrc: false,
      merchantName: '飞付通商户',
      merchantIcon: require('../assets/icon/merchant.svg')
    }
  },

  computed: {
    merchantDisplayName() {
      return this.payOrderInfo.mchName || this.merchantName
    },

    target() {
      if (this.$route.query && this.$route.query.target) {
        return this.$route.query.target
      }
      return wayCodeUtils.getPayWay() ? 'hub' : 'webpay'
    }
  },

  mounted() {
    document.title = '确认转账'
    this.setPayOrderInfo()
  },

  methods: {
    setPayOrderInfo() {
      const payWay = wayCodeUtils.getPayWay()
      getPayOrderInfo(payWay ? payWay.wayCode : '', false).then(res => {
        this.payOrderInfo = res || {}
        this.isProductQrc = this.payOrderInfo.productQrc === true
        this.loading = false
      }).catch(res => {
        this.$router.replace({ name: config.errorPageRouteName, params: { errInfo: res && res.msg ? res.msg : '请重新扫码或联系商户' } })
      })
    },

    tapFeedback(duration = 16) {
      if (window.navigator && typeof window.navigator.vibrate === 'function') {
        window.navigator.vibrate(duration)
      }
    },

    confirmTransfer() {
      if (this.loading || this.selectedAction !== 'transfer') return
      this.tapFeedback()

      const routeName = this.target === 'hub' && wayCodeUtils.getPayWay() ? 'Hub' : 'WebCashier'
      this.$router.push({
        name: routeName,
        params: { jeepayToken: this.$route.params.jeepayToken }
      })
    }
  }
}
</script>

<style lang="css" scoped>
.transfer-confirm-page {
  min-height: 100vh;
  background: #f5f6f8;
  color: #1f2733;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
  -webkit-text-size-adjust: 100%;
}

.transfer-main {
  padding: 42px 34px 180px;
}

.merchant-card,
.transfer-option-card {
  padding: 48px 44px 36px;
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 18px 46px rgba(21, 52, 96, 0.07);
}

.merchant-row {
  display: flex;
  align-items: center;
}

.merchant-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 78px;
  height: 78px;
  border-radius: 22px;
  background: #edf4ff;
}

.merchant-avatar img {
  width: 46px;
  height: 46px;
}

.merchant-meta {
  min-width: 0;
  margin-left: 22px;
}

.pay-title {
  color: #7a8494;
  font-size: 24px;
}

.merchant-name {
  margin-top: 8px;
  color: #1f2733;
  font-size: 30px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.transfer-option-card {
  margin-top: 24px;
  padding: 34px;
}

.transfer-option {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 96px;
  padding: 0 28px;
  border: 2px solid #2f80ed;
  border-radius: 18px;
  background: #f2f7ff;
  color: #172033;
  font-size: 30px;
  font-weight: 650;
  text-align: left;
}

.radio-dot {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 34px;
  margin-right: 20px;
  border: 3px solid #2f80ed;
  border-radius: 50%;
  background: #fff;
}

.transfer-option.active .radio-dot::after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #2f80ed;
  content: "";
  transform: translate(-50%, -50%);
}

.confirm-bar {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 20px 34px 34px;
  background: #fff;
  box-shadow: 0 -14px 34px rgba(15, 23, 42, 0.08);
}

.confirm-button {
  display: block;
  width: min(520px, 100%);
  height: 84px;
  margin: 0 auto;
  border: 0;
  border-radius: 14px;
  background: #2f80ed;
  color: #fff;
  font-size: 30px;
  font-weight: 700;
}

.confirm-button:disabled {
  background: #c7d3e4;
}
</style>
